import { get, post } from ".";

export const getSitePhotosApi = async (projectId, uploadBy, page, dateFrom, dateTo) => {
  return await get(`project/${projectId}/site-photos`, {
    params: { uploadBy, page, dateFrom, dateTo },
  });
};

export const downloadSitePhotosApi = async (projectId, photoIds) => {
  return await get(`project/${projectId}/site-photos/download-photos?photoIds=${photoIds}`);
};

export const uploadSitePhotoApi = async (projectId, params) => {
  return await post(`project/${projectId}/site-photos/new-photo`, params);
};

export const renameSitePhotoApi = async (projectId, photoId, name) => {
  return await post(`project/${projectId}/site-photos/rename-photo?photoId=${photoId}&name=${name}`);
};